import { render, staticRenderFns } from "./procedureList.vue?vue&type=template&id=11840afa&scoped=true&"
import script from "./procedureList.vue?vue&type=script&lang=js&"
export * from "./procedureList.vue?vue&type=script&lang=js&"
import style0 from "./procedureList.vue?vue&type=style&index=0&id=11840afa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11840afa",
  null
  
)

export default component.exports